import { ColGroupDef } from "ag-grid-enterprise";

export const useGroupedLengthTableData = () => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Grouped Length",
      children: [
        {
          field: "Molds",
          headerName: "Size",
          flex: 1,
        },
        {
          field: "Length",
          headerName: "Length",
          flex: 1,
        },
        {
          field: "WeightRounded",
          headerName: "Weight Rounded",
          flex: 1,
          minWidth: 130,
        },
        {
          field: "WeightOriginal",
          headerName: "Weight Original",
          flex: 1,
          valueGetter: (params) => {
            return params.data.WeightOriginal
              ? params.data.WeightOriginal.toFixed(2)
              : 0;
          },
          minWidth: 120,
        },
        {
          field: "Cuts",
          headerName: "# Cuts",
          flex: 1,
        },
        {
          field: "Undefined",
          headerName: "# Unidentified",
          flex: 1,
        },
        {
          field: "Scrapped",
          headerName: "# Scrapped",
          flex: 1,
        },
        {
          field: "Billets",
          headerName: "# Billets",
          flex: 1,
        },
      ],
    },
  ];

  return { columns };
};
